import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { cx } from '../utils';
import './Drawer.css';

const toCss = (value) => (typeof value === 'number' ? `${value}px` : value);

// O'ng tomondan chiqadigan panel (modal emas): fon qoraytirilmaydi, orqadagi sahifa bosiladigan bo'lib qoladi.
// Ochiq/yopiqlik tashqaridan: open + onClose. Esc bilan yopiladi (ustida modal ochiq bo'lmasa).
// actions — sarlavha o'ng tomonidagi tugmalar; loading — sarlavha ostida ingichka indikator.
// width — berilmasa CSS'dagi default (440px, tokenlardan hisoblangan); 640px dan tor ekranda to'liq kenglik.
function Drawer({
  open,
  onClose,
  title,
  actions,
  width,
  loading = false,
  closeLabel = 'Yopish',
  className,
  children,
  ...rest
}) {
  const titleId = useId();
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  });

  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (event) => {
      if (event.key !== 'Escape') return;
      // Ustida modal oyna ochiq bo'lsa, Esc avval o'shani yopadi.
      if (document.querySelector('[role="dialog"][aria-modal="true"]')) return;
      if (onCloseRef.current) onCloseRef.current();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open]);

  return createPortal(
    <aside
      {...rest}
      role="dialog"
      aria-labelledby={title ? titleId : undefined}
      aria-hidden={!open}
      className={cx('ui-drawer', open && 'ui-drawer--open', className)}
      style={width !== undefined ? { '--ui-drawer-width': toCss(width), ...rest.style } : rest.style}
    >
      <div className="ui-drawer__header">
        {title && (
          <h2 id={titleId} className="ui-drawer__title">
            {title}
          </h2>
        )}
        <div className="ui-drawer__actions">
          {actions}
          <button type="button" className="ui-drawer__close" onClick={onClose} aria-label={closeLabel}>
            <X aria-hidden="true" />
          </button>
        </div>
      </div>
      <div className={cx('ui-drawer__progress', loading && 'ui-drawer__progress--active')} aria-hidden="true" />
      <div className="ui-drawer__body">{children}</div>
    </aside>,
    document.body
  );
}

export default Drawer;
